import Vue from 'vue'
import { defineStore } from 'pinia'
import { ClvrScreenControlTemplateApiAdapter } from '../Adapters/ClvrScreenControlTemplateApiAdapter'
import { ClvrScreenControlApiAdapter } from '../Adapters/ClvrScreenControlApiAdapter'
import { ClvrScreenControlDto } from '../Types/ClvrScreenControlDto'
import { OperatingRoomApiAdapter } from '../../../dPbloc/vue/Adapters/OperatingRoomApiAdapter'
import { ScreenControlSallesBlocAssocDto } from '../Types/ScreenControlSallesBlocAssocDto'
import { ClvrScreenControlDataTypeApiAdapter } from '../Adapters/ClvrScreenControlDataTypeApiAdapter'
import { ClvrScreenControlTemplateDto } from '../Types/ClvrScreenControlTemplateDto'
import { OperationApiAdapter } from '../../../dPplanningOp/vue/Adapters/OperationApiAdapter'
import { ScOperationParam } from '../Types/ScOperationParam'

export const useScreenControlStore = defineStore('screenControl', () => {
    /**
     * ScreenControl process
     */
    const createScreenControl = (args: ClvrScreenControlDto) => {
        return Vue.$http
            .post('api/v1/screenControl/screenControl?fieldsets=rooms,default', new ClvrScreenControlApiAdapter(), args)
            .toPromise()
    }

    const loadScreenControl = (id: number) => {
        return Vue.$http
            .get(`api/v1/screenControl/screenControl/${id}?fieldsets=rooms,default`, new ClvrScreenControlApiAdapter())
            .toPromise()
    }

    const loadScreenControls = () => {
        return Vue.$http
            .get('api/v1/screenControl/screenControls?fieldsets=rooms,default', new ClvrScreenControlApiAdapter())
            .toPromise()
    }

    const loadScreenControlListByGroup = (groupId: number) => {
        return Vue.$http
            .get(`api/v1/screenControl/screenControls?groupId=${groupId}`, new ClvrScreenControlApiAdapter())
            .toPromise()
    }

    const updateScreenControl = (args: ClvrScreenControlDto) => {
        return Vue.$http
            .put(
                `api/v1/screenControl/screenControl/${args.id}?is_active&fieldsets=rooms,default`,
                new ClvrScreenControlApiAdapter(),
                args,
            )
            .toPromise()
    }

    const deleteScreenControl = (id: number) => {
        return Vue.$http
            .delete(`api/v1/screenControl/screenControl/${id}`, new ClvrScreenControlApiAdapter())
            .toPromise()
    }

    /**
     * Template process
     */
    const createTemplate = (args: ClvrScreenControlTemplateDto) => {
        return Vue.$http
            .post('api/v1/screenControl/template', new ClvrScreenControlTemplateApiAdapter(), args)
            .toPromise()
    }
    const loadScTemplate = (id: number) => {
        return Vue.$http
            .get(
                `api/v1/screenControl/template/${id}?fieldsets=default,datatypes`,
                new ClvrScreenControlTemplateApiAdapter(),
            )
            .toPromise()
    }

    const loadScTemplateWithEnabledDataType = (id: number) => {
        return Vue.$http
            .get(
                `api/v1/screenControl/template/${id}?fieldsets=default,datatypes&dataTypeEnabled=1`,
                new ClvrScreenControlTemplateApiAdapter(),
            )
            .toPromise()
    }

    const loadScTemplates = () => {
        return Vue.$http.get('api/v1/screenControl/templates', new ClvrScreenControlTemplateApiAdapter()).toPromise()
    }

    const updateTemplate = (args: ClvrScreenControlTemplateDto) => {
        return Vue.$http
            .put(`api/v1/screenControl/template/${args.id}`, new ClvrScreenControlTemplateApiAdapter(), args)
            .toPromise()
    }

    const deleteTemplate = (template: ClvrScreenControlTemplateDto) => {
        return Vue.$http
            .delete(`api/v1/screenControl/template/${template.id}`, new ClvrScreenControlTemplateApiAdapter())
            .toPromise()
    }

    /**
     *  Operating room process
     */
    const loadOperatingRooms = () => {
        return Vue.$http.get('api/bloc/blocs?populate=rooms', new OperatingRoomApiAdapter()).toPromise()
    }

    /**
     * Room process
     */
    const createScreenControlSalleBlocAssoc = (args: ScreenControlSallesBlocAssocDto) => {
        return Vue.$http
            .post('api/v1/screenControl/screenControlRoom', new ClvrScreenControlApiAdapter(), args)
            .toPromise()
    }

    /**
     * Process to dataType
     */
    const loadDefaultDataTypes = () => {
        return Vue.$http
            .get('api/v1/screenControl/dataType?populate=dataTypeChildren', new ClvrScreenControlDataTypeApiAdapter())
            .toPromise()
    }

    /**
     * Load list of operation
     */
    const loadOperations = (params: ScOperationParam) => {
        return Vue.$http.get(`api/v1/screenControl/operations`, new OperationApiAdapter(), params)
    }

    return {
        createScreenControl,
        loadScreenControl,
        loadScreenControls,
        loadScreenControlListByGroup,
        updateScreenControl,
        deleteScreenControl,
        createTemplate,
        loadScTemplate,
        loadScTemplateWithEnabledDataType,
        loadScTemplates,
        updateTemplate,
        deleteTemplate,
        loadOperatingRooms,
        createScreenControlSalleBlocAssoc,
        loadDefaultDataTypes,
        loadOperations,
    }
})
